import { useNavigate } from "react-router-dom";
import useScreenSize from "../../../../hooks/useScreenSize";

// CONSTANTS
import { MOBILE_OPERATE_WIDTH } from "../../../OperateMEP/constants";

// REDUX
import { useDispatch } from "react-redux";
import { updateCryptoStep } from "../../../../store/slices/cryptoSlice";

// COMPONENTS
import { ModalBody, ModalHeader } from "@nextui-org/react";
import { ButtonsFooter } from "../ButtonsFooter/ButtonsFooter";

// STYLES
import styles from "./JointSignatureModal.module.scss";

// ASSETS
import InfoIcon from "../../../../assets/icons/info-icon.svg?react";

interface Props {
  onClose: () => void;
  isCryptoOnly: boolean;
}

const JointSignatureModal = ({ onClose, isCryptoOnly }: Props) => {
  const { isMobile } = useScreenSize(MOBILE_OPERATE_WIDTH);
  const navigate = useNavigate();
  const { header, flexContainer, description, headerContainer, icon } = styles;
  const dispatch = useDispatch();

  return (
    <>
      <ModalHeader className={headerContainer}>
        <InfoIcon className={icon} />
        <span className={header}>Firma conjunta</span>
      </ModalHeader>

      <ModalBody className={`${flexContainer} py-[0] px-[2rem]`}>
        <span className={description}>
          Al tener firma conjunta, para abrir la cuenta es necesario contactar a
          soporte.
        </span>
      </ModalBody>

      <ButtonsFooter
        isMobile={isMobile}
        primaryButton={{
          text: "Contactar a soporte",
          handleClick: () => {
            if (!isCryptoOnly) {
              onClose();
              navigate("/ayuda");
            }
          },
          isDisabled: false,
        }}
        {...(!isCryptoOnly && {
          secondaryButton: {
            text: "Volver",
            handleClick: () => dispatch(updateCryptoStep("DETAILS")),
            isDisabled: false,
          },
        })}
      />
    </>
  );
};
export default JointSignatureModal;
